import React from "react";

import introImg from '../../assets/img/themap-store.png';

const Intro = () => {
  return (
    <div className="grid intro cross-center">
      <div className="u-16 u-ls">
        <h1>theMAP Store</h1>
        <p>
          Мы сделали для вас пример интернет-магазина. Здесь можно посмотреть, как ваши покупатели будут видеть платежи
          через theMAP.
        </p>

        <p>
          Сейчас вам нужно собрать корзину из предложенных товаров и оплатить заказ. Деньги с карты не спишутся, можете
          использовать любые карточные данные.
        </p>
      </div>
      <div className="u grid center hor-padding-10">
        <img src={introImg} alt="theMAP Store" className="intro__img img"/>
      </div>
    </div>
  );
};

export default Intro;
